import { ScissorsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CutScissors = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <ScissorsIcon size={Sizes[size]} {...rest} />;
};

CutScissors.displayName = 'CutScissors';
